export default "__VITE_ASSET__D7d2kq7Q__"